import React, { useState, useEffect } from 'react';
import { ShoppingCart, Phone, Download, Star, CheckCircle, Award, Truck, Shield, Menu, X, Plus, Minus, User, ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { useToast } from '../hooks/use-toast';
import { Toaster } from '../components/ui/sonner';
import { toast } from 'sonner';

const Home = () => {
  const [cart, setCart] = useState([]);
  const [cartOpen, setCartOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [quantities, setQuantities] = useState({});
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userName, setUserName] = useState('');
  const [currentSlide, setCurrentSlide] = useState(0);

  const promoSlides = [
    {
      image: 'https://customer-assets.emergentagent.com/job_d241d00a-8bdb-4a8f-a7ed-0a172ac84b36/artifacts/sb5617wj_photo_2026-01-19%2017.46.39.jpeg',
      title: 'POWER YOUR GAINS',
      subtitle: 'Elite Nutrition for Serious Performance',
      cta: 'Exclusive Deals on Beast Root Essentials'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_d241d00a-8bdb-4a8f-a7ed-0a172ac84b36/artifacts/3lvn4hyz_photo_2026-01-19%2017.47.00.jpeg',
      title: 'UNLEASH THE BEAST',
      subtitle: 'Maximum Strength & Performance',
      cta: 'Premium Quality You Can Trust'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_d241d00a-8bdb-4a8f-a7ed-0a172ac84b36/artifacts/3ehmaogx_photo_2026-01-19%2017.46.09.jpeg',
      title: 'BUILD SERIOUS MASS',
      subtitle: 'Lab-Tested Formula for Real Results',
      cta: 'Trusted by Athletes Nationwide'
    }
  ];

  const products = [
    {
      id: 1,
      name: 'Beast Root Mass Gainer',
      image: 'https://customer-assets.emergentagent.com/job_d241d00a-8bdb-4a8f-a7ed-0a172ac84b36/artifacts/3ehmaogx_photo_2026-01-19%2017.46.09.jpeg',
      mrp: 4399,
      price: 3079,
      discount: 30,
      description: 'Premium mass gainer with 84g protein and 1110 calories per serving. Engineered for extreme muscle growth and faster recovery.',
      bestSeller: true
    },
    {
      id: 2,
      name: 'Beast Root Protein Isolate',
      image: 'https://customer-assets.emergentagent.com/job_d241d00a-8bdb-4a8f-a7ed-0a172ac84b36/artifacts/sb5617wj_photo_2026-01-19%2017.46.39.jpeg',
      mrp: 5500,
      price: 3850,
      discount: 30,
      description: 'Premium whey isolate with 30g protein per serving. Pure, fast-absorbing protein for maximum muscle growth and strength.',
      bestSeller: true
    },
    {
      id: 3,
      name: 'Beast Root Creatine',
      image: 'https://customer-assets.emergentagent.com/job_d241d00a-8bdb-4a8f-a7ed-0a172ac84b36/artifacts/3lvn4hyz_photo_2026-01-19%2017.47.00.jpeg',
      mrp: 1500,
      price: 600,
      discount: 60,
      description: 'Pure creatine monohydrate for explosive strength and power. Unleash the beast with 5g per serving for maximum performance.',
      bestSeller: true
    },
    {
      id: 4,
      name: 'Multivitamin',
      image: 'https://customer-assets.emergentagent.com/job_d241d00a-8bdb-4a8f-a7ed-0a172ac84b36/artifacts/5e7t8u44_photo_2026-01-19%2017.47.17.jpeg',
      mrp: 800,
      price: 320,
      discount: 60,
      description: 'Complete daily formula with essential vitamins and minerals. Boost immunity, energy, and overall health with 60 capsules.'
    },
    {
      id: 5,
      name: 'Omega 3',
      image: 'https://customer-assets.emergentagent.com/job_d241d00a-8bdb-4a8f-a7ed-0a172ac84b36/artifacts/4eqdn819_photo_2026-01-19%2017.47.24.jpeg',
      mrp: 800,
      price: 320,
      discount: 60,
      description: 'High potency fish oil for heart and joint health. Premium omega-3 fatty acids with 90 softgels for optimal wellness.'
    },
    {
      id: 6,
      name: 'Protein Oats',
      image: 'https://customer-assets.emergentagent.com/job_luxsupplements/artifacts/me2rmd49_photo_2026-01-19%2017.47.30.jpeg',
      mrp: 600,
      price: 420,
      discount: 30,
      description: 'High fiber and energy packed protein oats with 30g protein per serving. Perfect breakfast for sustained energy and muscle building.'
    },
    {
      id: 7,
      name: 'Protein Muesli',
      image: 'https://customer-assets.emergentagent.com/job_luxsupplements/artifacts/5sn17x13_photo_2026-01-19%2017.47.39.jpeg',
      mrp: 600,
      price: 420,
      discount: 30,
      description: 'Crunchy whole grain muesli with 30g protein per serving. Delicious and nutritious breakfast option for fitness enthusiasts.'
    },
    {
      id: 8,
      name: 'Beast Root Pre-Workout',
      image: 'https://customer-assets.emergentagent.com/job_luxsupplements/artifacts/3mtpbavv_photo_2026-01-19%2017.48.26.jpeg',
      mrp: 3000,
      price: 2100,
      discount: 30,
      description: 'Extreme pre-workout with 10g citrulline and 4g beta-alanine. Heavy dose explosive energy for maximum workout intensity.'
    },
    {
      id: 9,
      name: 'Collagen Peptides',
      image: 'https://customer-assets.emergentagent.com/job_luxsupplements/artifacts/cvxubqar_photo_2026-01-19%2017.48.40.jpeg',
      mrp: 1500,
      price: 450,
      discount: 70,
      description: 'Premium collagen for youthful skin and joint support. Heavy glass bottle with premium embossed texture for luxury feel.'
    },
    {
      id: 10,
      name: 'Glutathione + Vit C',
      image: 'https://customer-assets.emergentagent.com/job_luxsupplements/artifacts/9gr8kxa1_photo_2026-01-19%2017.48.46.jpeg',
      mrp: 1600,
      price: 1120,
      discount: 30,
      description: 'Master antioxidant and brightening formula. Premium embossed texture with heavy glass for skin health and detoxification.'
    },
    {
      id: 11,
      name: 'BCAA',
      image: 'https://customer-assets.emergentagent.com/job_luxsupplements/artifacts/m4afdsnm_photo_2026-01-19%2017.48.54.jpeg',
      mrp: 2000,
      price: 1400,
      discount: 30,
      description: 'Muscle recovery and  endurance formula with 2:1:1 ratio. 30 servings of extreme performance support for intense training.'
    },
    {
      id: 12,
      name: 'EAA',
      image: 'https://customer-assets.emergentagent.com/job_luxsupplements/artifacts/tvqiysbl_photo_2026-01-19%2017.49.02.jpeg',
      mrp: 2000,
      price: 1400,
      discount: 30,
      description: 'Complete amino matrix with essential amino acids. Anabolic fuel for maximum muscle growth and recovery. 30 servings.'
    },
    {
      id: 13,
      name: 'MK-677',
      image: 'https://customer-assets.emergentagent.com/job_luxsupplements/artifacts/bh20ayiz_photo_2026-01-19%2017.49.11.jpeg',
      mrp: 5000,
      price: 3500,
      discount: 30,
      description: 'Growth hormone secretagogue for extreme muscle gains. 60 capsules of pure power for serious bodybuilders and athletes.'
    },
    {
      id: 14,
      name: 'Fat Burner',
      image: 'https://customer-assets.emergentagent.com/job_luxsupplements/artifacts/a66r7cao_photo_2026-01-19%2017.49.16.jpeg',
      mrp: 1600,
      price: 1120,
      discount: 30,
      description: 'Thermogenic shred formula for metabolism boosting. 60 capsules of powerful fat burning support for lean physique goals.'
    },
    {
      id: 15,
      name: 'Peanut Butter',
      image: 'https://customer-assets.emergentagent.com/job_luxsupplements/artifacts/kc1crw3f_photo_2026-01-19%2017.49.31.jpeg',
      mrp: 400,
      price: 400,
      discount: 0,
      description: 'Ultra-premium artisanal high protein dark chocolate & peanut butter. Small batch crafted with 30g protein per 100g.'
    },
    {
      id: 16,
      name: 'Protein Bar',
      image: 'https://customer-assets.emergentagent.com/job_luxsupplements/artifacts/a4emo5vu_WhatsApp%20Image%202026-01-18%20at%2014.50.55.jpeg',
      mrp: 100,
      price: 70,
      discount: 30,
      description: 'Ultra-premium artisanal protein bar with 30g protein. Convenient on-the-go nutrition with rich dark chocolate and peanut flavor.'
    }
  ];

  useEffect(() => {
    const initialQuantities = {};
    products.forEach(product => {
      initialQuantities[product.id] = 1;
    });
    setQuantities(initialQuantities);

    // Check if user is logged in
    const savedUser = localStorage.getItem('beastroot_user');
    if (savedUser) {
      setIsLoggedIn(true);
      setUserName(savedUser);
    }
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % promoSlides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const handleQuantityChange = (productId, change) => {
    setQuantities(prev => ({
      ...prev,
      [productId]: Math.max(1, (prev[productId] || 1) + change)
    }));
  };

  const addToCart = (product) => {
    const quantity = quantities[product.id] || 1;
    const existingItem = cart.find(item => item.id === product.id);
    
    if (existingItem) {
      setCart(cart.map(item => 
        item.id === product.id 
          ? { ...item, quantity: item.quantity + quantity }
          : item
      ));
      toast.success(`Updated ${product.name} quantity in cart`);
    } else {
      setCart([...cart, { ...product, quantity }]);
      toast.success(`${product.name} added to cart`);
    }
  };

  const orderNow = (product) => {
  const quantity = quantities[product.id] || 1;
  const total = product.price * quantity;

  const message = `Hello BEAST ROOT,

I want to order:

Product: ${product.name}
Quantity: ${quantity}
Price: ₹${product.price} each
Total Amount: ₹${total}

Please confirm availability.`;

  const whatsappUrl = `https://wa.me/916266403420?text=${encodeURIComponent(message)}`;
  window.open(whatsappUrl, '_blank');
};

  const checkout = () => {
    const cartItems = cart.map(item => 
      `${item.name}\nQuantity: ${item.quantity}\nPrice: ₹${item.price} each\nSubtotal: ₹${item.price * item.quantity}`
    ).join('\n\n');
    const total = cart.reduce((sum, item) => sum + (item.price * item.quantity), 0);
    const message = `Hello BEAST ROOT,\n\nI want to order:\n\n${cartItems}\n\n━━━━━━━━━━━━━━━━\nTotal Amount: ₹${total}\nPlease confirm availability.`;
    const whatsappUrl = `https://wa.me/916266403420?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % promoSlides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + promoSlides.length) % promoSlides.length);
  };

  const totalItems = cart.reduce((sum, item) => sum + item.quantity, 0);

  return (
    <div className="min-h-screen bg-black text-white">
      <Toaster position="top-center" richColors />
      
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-black border-b border-white/10 backdrop-blur-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            <div className="flex items-center gap-3">
              <img
  src="/LOGOBEASTROOT.png"
  alt="BEAST ROOT"
  className="h-44 w-auto object-contain -ml-10"
 />
            </div>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex items-center gap-8">
              <button onClick={() => scrollToSection('products')} className="nav-link">Products</button>
              <button onClick={() => scrollToSection('certifications')} className="nav-link">Certifications</button>
              <button onClick={() => scrollToSection('why-beast-root')} className="nav-link">Why Us</button>
              <button onClick={() => scrollToSection('contact')} className="nav-link">Contact</button>
            </nav>

            <div className="flex items-center gap-4">
              
              <button 
                onClick={() => setCartOpen(!cartOpen)}
                className="relative p-2 rounded-lg hover:bg-white/5 transition-all"
              >
                <ShoppingCart className="w-6 h-6 text-[#D4AF37]" />
                {totalItems > 0 && (
                  <span className="absolute -top-1 -right-1 bg-[#D4AF37] text-black text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center">
                    {totalItems}
                  </span>
                )}
              </button>

              <button
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                className="md:hidden p-2 rounded-lg hover:bg-white/5 transition-all"
              >
                {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
              </button>
            </div>
          </div>

          {/* Mobile Menu */}
          {mobileMenuOpen && (
            <div className="md:hidden py-4 border-t border-white/10">
              <nav className="flex flex-col gap-4">
                <button onClick={() => scrollToSection('products')} className="nav-link text-left">Products</button>
                <button onClick={() => scrollToSection('certifications')} className="nav-link text-left">Certifications</button>
                <button onClick={() => scrollToSection('why-beast-root')} className="nav-link text-left">Why Us</button>
                <button onClick={() => scrollToSection('contact')} className="nav-link text-left">Contact</button>
              </nav>
            </div>
          )}
        </div>
      </header>

      {/* Cart Sidebar */}
      {cartOpen && (
        <div className="fixed inset-0 z-50 mt-20">
          <div className="absolute inset-0 bg-black/80" onClick={() => setCartOpen(false)} />
          <div className="absolute right-0 top-0 bottom-0 w-full max-w-md bg-zinc-900 border-l border-white/10 overflow-y-auto">
            <div className="p-6">
              <div className="flex items-center justify-between mb-6">
                <h2 className="text-2xl font-bold luxury-gold-text">Your Cart</h2>
                <button onClick={() => setCartOpen(false)}>
                  <X className="w-6 h-6" />
                </button>
              </div>

              {cart.length === 0 ? (
                <p className="text-white/60 text-center py-8">Your cart is empty</p>
              ) : (
                <>
                  <div className="space-y-4 mb-6">
                    {cart.map(item => (
                      <div key={item.id} className="flex gap-4 p-4 bg-black/50 rounded-lg border border-[#D4AF37]/20">
                        <img src={item.image} alt={item.name} className="w-20 h-20 object-cover rounded" />
                        <div className="flex-1">
                          <h3 className="font-semibold text-sm mb-1">{item.name}</h3>
                          <p className="text-[#D4AF37] font-bold">₹{item.price}</p>
                          <p className="text-white/60 text-sm">Qty: {item.quantity}</p>
                          <p className="text-white/80 text-sm font-semibold">Subtotal: ₹{item.price * item.quantity}</p>
                        </div>
                        <button
                          onClick={() => setCart(cart.filter(i => i.id !== item.id))}
                          className="text-red-400 hover:text-red-300"
                        >
                          <X className="w-5 h-5" />
                        </button>
                      </div>
                    ))}
                  </div>

                  <div className="border-t border-white/10 pt-4 mb-6">
                    <div className="flex justify-between text-xl font-bold mb-2">
                      <span>Total:</span>
                      <span className="luxury-gold-text">
                        ₹{cart.reduce((sum, item) => sum + (item.price * item.quantity), 0)}
                      </span>
                    </div>
                    <p className="text-white/60 text-sm">Delivering all over India</p>
                  </div>

                  <Button 
                    onClick={checkout}
                    className="w-full btn-primary h-14 text-lg"
                  >
                    <Phone className="w-5 h-5 mr-2" />
                    Order on WhatsApp
                  </Button>
                </>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center justify-center pt-20 overflow-hidden">
  
  {/* Background Image */}
  <div
    className="absolute inset-0 bg-center bg-cover opacity-20"
    style={{ backgroundImage: "url('/BACKOOOO.jpeg')" }}
  />

  {/* Dark Overlay */}
  <div className="absolute inset-0 bg-black/70" />

  {/* Content */}
  <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
    
    <h1 className="hero-title-refined mb-6 glow-text">
      BEAST ROOT
    </h1>

    <p className="text-xl sm:text-2xl text-white/90 mb-4 font-medium">
      Premium Sports Nutrition | Lab Tested | Trusted Quality
    </p>

    <div className="flex flex-wrap justify-center gap-6 mb-12">
      <div className="flex items-center gap-2">
        <Truck className="w-6 h-6 text-[#D4AF37]" />
        <span className="text-white/80">Fast Delivery</span>
      </div>
      <div className="flex items-center gap-2">
        <Shield className="w-6 h-6 text-[#D4AF37]" />
        <span className="text-white/80">Lab Tested</span>
      </div>
      <div className="flex items-center gap-2">
        <Award className="w-6 h-6 text-[#D4AF37]" />
        <span className="text-white/80">FSSAI Certified</span>
      </div>
    </div>

    <div className="flex flex-col sm:flex-row gap-4 justify-center">
      <Button
        onClick={() => scrollToSection('products')}
        className="btn-primary px-8 h-14 text-lg"
      >
        Shop Supplements
      </Button>
      <Button
        onClick={() => window.open('https://wa.me/916266403420', '_blank')}
        className="btn-secondary px-8 h-14 text-lg"
      >
        Order on WhatsApp
      </Button>
    </div>

  </div>
</section>      
      {/* Why Beast Root Section */}
      <section id="why-beast-root" className="py-20 bg-gradient-to-b from-zinc-900 to-black">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="section-title mb-4">Why Beast Root?</h2>
          <p className="text-center text-white/60 mb-16 text-lg">Building trust through quality and excellence</p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="feature-card text-center">
              <div className="icon-wrapper mx-auto mb-4">
                <CheckCircle className="w-8 h-8" />
              </div>
              <h3 className="text-xl font-bold mb-2">100% Authentic Supplements</h3>
              <p className="text-white/60">Genuine products with zero compromise on quality</p>
            </div>

            <div className="feature-card text-center">
              <div className="icon-wrapper mx-auto mb-4">
                <Shield className="w-8 h-8" />
              </div>
              <h3 className="text-xl font-bold mb-2">Lab Tested & Quality Checked</h3>
              <p className="text-white/60">Third-party verified for purity and potency</p>
            </div>

            <div className="feature-card text-center">
              <div className="icon-wrapper mx-auto mb-4">
                <Truck className="w-8 h-8" />
              </div>
              <h3 className="text-xl font-bold mb-2">Fast Dispatch</h3>
              <p className="text-white/60">All India delivery with secure packaging</p>
            </div>

            <div className="feature-card text-center">
              <div className="icon-wrapper mx-auto mb-4">
                <Award className="w-8 h-8" />
              </div>
              <h3 className="text-xl font-bold mb-2">Premium Grade Raw Materials</h3>
              <p className="text-white/60">Only the finest ingredients for maximum results</p>
            </div>

            <div className="feature-card text-center">
              <div className="icon-wrapper mx-auto mb-4">
                <Star className="w-8 h-8" />
              </div>
              <h3 className="text-xl font-bold mb-2">Trusted by Serious Athletes</h3>
              <p className="text-white/60">Preferred choice of fitness professionals</p>
            </div>

            <div className="feature-card text-center">
              <div className="icon-wrapper mx-auto mb-4">
                <CheckCircle className="w-8 h-8" />
              </div>
              <h3 className="text-xl font-bold mb-2">FSSAI Certified</h3>
              <p className="text-white/60">Compliant with food safety standards</p>
            </div>
          </div>
        </div>
      </section>

      {/* Products Section */}
      <section id="products" className="py-20 bg-black">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="section-title mb-4">Our Premium Range</h2>
          <p className="text-center text-white/60 mb-16 text-lg">Lab-tested supplements for your fitness journey</p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {products.map(product => (
              <div key={product.id} className="product-card group">
                {product.bestSeller && (
                  <div className="absolute top-4 left-4 z-10">
                    <Badge className="bg-[#D4AF37] text-black font-bold">BEST SELLER</Badge>
                  </div>
                )}
                
                {product.discount > 0 && (
                  <div className="absolute top-4 right-4 z-10">
                    <div className="bg-[#D4AF37] text-black font-bold px-3 py-1 rounded-lg shadow-lg">
                      {product.discount}% OFF
                    </div>
                  </div>
                )}

                <div className="relative h-64 mb-4 overflow-hidden rounded-lg bg-zinc-900">
                  <img 
                    src={product.image} 
                    alt={product.name}
                    className="w-full h-full object-contain p-4 group-hover:scale-105 transition-transform duration-500"
                  />
                </div>

                <h3 className="font-bold text-lg mb-2 line-clamp-2">{product.name}</h3>
                <p className="text-white/60 text-sm mb-4 line-clamp-2">{product.description}</p>

                <div className="mb-4">
                  {product.discount > 0 ? (
                    <div className="flex items-center gap-2">
                      <span className="text-white/40 line-through text-sm">₹{product.mrp}</span>
                      <span className="text-[#D4AF37] font-bold text-2xl">₹{product.price}</span>
                    </div>
                  ) : (
                    <span className="text-[#D4AF37] font-bold text-2xl">₹{product.price}</span>
                  )}
                </div>

                <div className="flex items-center gap-2 mb-4">
                  <button
                    onClick={() => handleQuantityChange(product.id, -1)}
                    className="w-10 h-10 flex items-center justify-center bg-white/5 hover:bg-[#D4AF37] hover:text-black rounded-lg transition-all border border-[#D4AF37]/30"
                  >
                    <Minus className="w-4 h-4" />
                  </button>
                  <div className="flex-1 text-center font-bold text-lg">
                    {quantities[product.id] || 1}
                  </div>
                  <button
                    onClick={() => handleQuantityChange(product.id, 1)}
                    className="w-10 h-10 flex items-center justify-center bg-white/5 hover:bg-[#D4AF37] hover:text-black rounded-lg transition-all border border-[#D4AF37]/30"
                  >
                    <Plus className="w-4 h-4" />
                  </button>
                </div>

                <div className="flex flex-col gap-2">
                  <Button 
                    onClick={() => addToCart(product)}
                    className="btn-secondary w-full"
                  >
                    <ShoppingCart className="w-4 h-4 mr-2" />
                    Add to Cart
                  </Button>
                   <Button 
                    onClick={() => orderNow(product)} 
                    className="btn-primary w-full group"
                  >
                    <Phone className="w-4 h-4 mr-2 group-hover:rotate-12 transition-transform" />
                    <span className="luxury-gold-text font-black tracking-[0.3em] text-black">
                      ORDER NOW
                    </span>
                  </Button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Certifications */}
      <section id="certifications" className="py-20 bg-gradient-to-b from-zinc-900 to-black">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="section-title mb-4">Certifications & Quality</h2>
          <p className="text-center text-white/60 mb-16 text-lg">Our commitment to safety and excellence</p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
            <div className="feature-card text-center">
              <div className="icon-wrapper mx-auto mb-4">
                <Award className="w-10 h-10" />
              </div>
              <h3 className="text-2xl font-bold mb-4">FSSAI Certified</h3>
              <p className="text-white/60 mb-6">Food Safety and Standards Authority of India approved</p>
              <Button 
                onClick={() => window.open('https://customer-assets.emergentagent.com/job_luxsupplements/artifacts/qw60met4_NEW%20FOOD%20%20LICENSE%20RMS.pdf', '_blank')}
                className="btn-primary"
              >
                <Download className="w-4 h-4 mr-2" />
                Download FSSAI Report
              </Button>
            </div>

            <div className="feature-card text-center">
              <div className="icon-wrapper mx-auto mb-4">
                <Shield className="w-10 h-10" />
              </div>
              <h3 className="text-2xl font-bold mb-4">ISO Certified</h3>
              <p className="text-white/60 mb-6">International quality management standards compliance</p>
              <Button 
                onClick={() => window.open('https://customer-assets.emergentagent.com/job_luxsupplements/artifacts/21xojmxd_rms%20iso.pdf', '_blank')}
                className="btn-primary"
              >
                <Download className="w-4 h-4 mr-2" />
                Download ISO Certificate
              </Button>
            </div>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            <div className="text-center">
              <CheckCircle className="w-8 h-8 text-[#D4AF37] mx-auto mb-2" />
              <p className="text-white/80 font-semibold">Lab Tested</p>
            </div>
            <div className="text-center">
              <CheckCircle className="w-8 h-8 text-[#D4AF37] mx-auto mb-2" />
              <p className="text-white/80 font-semibold">Quality Assured</p>
            </div>
            <div className="text-center">
              <CheckCircle className="w-8 h-8 text-[#D4AF37] mx-auto mb-2" />
              <p className="text-white/80 font-semibold">100% Authentic</p>
            </div>
            <div className="text-center">
              <CheckCircle className="w-8 h-8 text-[#D4AF37] mx-auto mb-2" />
              <p className="text-white/80 font-semibold">Safe & Pure</p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact */}
      <section id="contact" className="py-20 bg-black">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="section-title mb-4">Get In Touch</h2>
          <p className="text-white/60 mb-12 text-lg">Have questions? We're here to help</p>
          
          <div className="feature-card">
            <div className="icon-wrapper mx-auto mb-6">
              <Phone className="w-10 h-10" />
            </div>
            <h3 className="text-2xl font-bold mb-4">Order on WhatsApp</h3>
            <p className="text-white/60 mb-6">Chat with us for instant order placement and support</p>
            <Button
  onClick={() => {
    const message = "Hello Beast Root, I want to order supplements.";
    window.open(
      `https://wa.me/916266403420?text=${encodeURIComponent(message)}`,
      "_blank"
    );
  }}
  className="btn-primary px-8 h-14 text-lg"
>
              <Phone className="w-5 h-5 mr-2" />
              Chat on WhatsApp
            </Button>
          </div>  
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-black border-t border-white/10 py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h3 className="text-3xl font-bold luxury-gold-text mb-4">BEAST ROOT</h3>
            <p className="text-white/60 mb-2">Owner: Piyush Jain</p>
            <p className="text-white/40 text-sm mb-4">Indore</p>
            <p className="text-white/60 mb-6">WhatsApp: +91 6266403420</p>
            <p className="text-white/40 text-sm">Online payments coming soon</p>
            <p className="text-white/40 text-sm mt-8">© 2026 Beast Root. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};  

export default Home;